import * as React from 'react';

import { createIcon } from '../Icon';
export const NavigationIcon = createIcon(
  <polygon points="3 11 22 2 13 21 11 13 3 11" />,
  'NavigationIcon'
);
